module.exports = __webpack_public_path__ + "static/media/rounded-tag.801b8318.svg";